import React from "react";
import { connect } from "react-redux";
import { Button, Col, Form, Row } from "react-bootstrap";
import Select from "react-select";
import {
  getContactsActions,
  getUserRolesAction,
  getOwnerContactsAction,
} from "./../../../actions/UserActions";
import { getVendorTransactionsAction } from "../../../actions/VendorTransactionActions";
import {
  getAllTransactionsAction,
  getTransactionDataAction,
  getAllTasksAction,
  createTaskAction,
  getAllTransactionsActionNew,
} from "../../../actions/TransactionActions";
import {
  getContingencyData,
  toastMessage,
  convertTimeToMinutes,
  convertTZ,
  cryptoTokenDecode,
} from "../../Common/Common";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRange } from "@material-ui/icons";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import { REACT_APP_CRYPTO_SECRET_KEY } from "../../../config/Constants";
var CryptoJS = require("crypto-js");

class ExisitingTransaction extends React.Component {
  constructor(props) {
    super(props);
    var userType = cryptoTokenDecode().usertype;
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      contacts: [],
      transactions: [],
      transactionData: [],
      artist: {
        firstname: "",
        lastname: "",
        mobileNumber: parseInt(""),
        email: "",
        id: "",
      },
      contingencies: [],
      transactionId: "",
      eventTitle: "",
      eventStart: moment()
        .startOf("day")
        .add(12, "hours"),
      eventEnd: moment()
        .startOf("day")
        .add(13, "hours"),
      eventTime: 0,
      userType: userType.toUpperCase(),
      currentRole: !!currentType ? currentType.toUpperCase() : "",
      selectedDuration: "",
      errors: "",
      permissionArray: [],
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.getUserPermissions();
    this.getAllContacts();
    //this.getOwnerContacts();

    // if (
    //   this.state.userType === message.VENDOR &&
    //   this.state.currentRole === message.BUYERAGENT
    // ) {
    //   let userId = localStorage.getItem("ID");
    //   this.getAllTransactions(userId);
    // }

    // if (
    //   this.state.userType === message.VENDOR
    // ) {
    //   this.getAllTransactionsForVendor();
    // }
  }

  getUserPermissions() {
    if (this.state.userType === "VENDOR") {
      let permission = localStorage.getItem("otherInfo");
      let permissionarray;
      if (permission) {
        let bytes = CryptoJS.AES.decrypt(
          permission,
          REACT_APP_CRYPTO_SECRET_KEY
        );
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        // console.log("getUserPermissions decryptedData39", decryptedData);
        permissionarray = decryptedData.split(",");
        // console.log("getUserPermissions permissionarray", permissionarray);
        if (!permissionarray.includes(message.manage_master_campaign)) {
          // so there is no permissions, hence disabling all feilds.
          this.setState({
            disableAll: true,
          });
        }
        this.setState({ permissionArray: permissionarray });
      }
    }
  }

  checkPermission(checkFor) {
    if (this.state.userType === message.ACCTOWNER) {
      return true;
    } else {
      const hasSome =
        this.state.permissionArray &&
        this.state.permissionArray.length > 0 &&
        checkFor.some((item) => this.state.permissionArray.includes(item));
      return hasSome;
    }
  }

  getAllContacts() {
    // this.props.getContactsActions().then((res) => {
    //   this.props.getUserRolesAction();
    //   this.setState({
    //     contacts: this.props.contacts || [],
    //   });
    // });
    let rolename = "admin";
    if (this.state.userType === message.VENDOR) {
      rolename = "ep";
      this.props
        .getContactsActions(
          rolename,
          "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
        )
        .then((res) => {
          this.props.getUserRolesAction(
            "?id=" + localStorage.getItem("ownerId")
          );
          this.setState({
            contacts: this.props.contacts || [],
          });
        });
    } else {
      this.props.getContactsActions().then((res) => {
        this.props.getUserRolesAction();
        this.setState({
          contacts: this.props.contacts || [],
          // showLoader: false,
        });
      });
    }
  }

  getOwnerContacts() {
    let ownerId =
      this.state.userType === message.ACCTOWNER
        ? localStorage.getItem("ID")
        : localStorage.getItem("ownerId");

    this.props.getOwnerContactsAction(ownerId).then((res) => {
      this.setState({
        contacts: this.props.contacts || [],
      });
    });
  }

  handleArtistSelection(e) {
    if (e && this.state.artist.id !== e.id) {
      this.setState({
        artist: {
          firstname: e.firstname,
          lastname: e.lastname,
          mobileNumber: e.mobileNumber,
          email: e.email,
          id: e.id,
        },
      });

      this.getAllTransactions(e.id);
    }
  }

  handleTransactionSelection(e) {
    if (e) {
      this.setState({
        transactionId: e.id,
        contingencies: e.contingencies,
      });

      this.getTransactionData(e.id);
    }
  }

  getAllTransactions(id) {
    this.props.getAllTransactionsAction().then((res) => {
      this.props.getVendorTransactionsAction(id).then((vendorRes) => {
        this.setState({
          transactions: this.props.vendorTransactions.data || [],
        });
      });
    });
  }

  getAllTransactionsForVendor() {
    this.props.getAllTransactionsActionNew().then((res) => {
      this.setState({
        transactions: this.props.transactions.data || [],
      });
    });
  }

  getTransactionData(id) {
    this.props.getTransactionDataAction(id).then((res) => {
      this.setState({
        transactionData: this.props.transactionData,
      });
      this.setDefaultDate(this.props.transactionData.startDate);
    });
  }

  handleEventTitleChange(e) {
    this.setState({
      eventTitle: e,
    });
  }

  // handleEventStartChange(date, type) {
  // 	let dateStr = moment(date).format("YYYY-MM-DD");
  // 	let timeStr = moment(date).format("HH:mm");

  // 	if (type == "time") {
  // 		dateStr = moment(this.state.eventStart).format("YYYY-MM-DD");
  // 	}

  // 	let finalDate = moment(dateStr + " " + timeStr);
  // 	let timeStamp = new Date(finalDate.format('YYYY-MM-DDTHH:mm:ssZ'))
  // 	let formatedDate = moment(timeStamp.getTime()).format('YYYY-MM-DD HH:mm:ss');

  // 	let eventDate = moment.tz(formatedDate, 'YYYY-MM-DDTHH:mm:ssZ',
  // 	this.state.transactionData.userTimezone).utc().format()

  // 	this.setState({
  // 		eventStart: eventDate
  // 	});
  // }

  // handleEventEndChange(date, type) {
  // 	let dateStr = moment(date).format("YYYY-MM-DD");
  // 	let timeStr = moment(date).format("HH:mm");

  // 	if (type == "time") {
  // 		dateStr = moment(this.state.eventStart).format("YYYY-MM-DD");
  // 	}

  // 	let finalDate = moment(dateStr + " " + timeStr);
  // 	let timeStamp = new Date(finalDate.format('YYYY-MM-DDTHH:mm:ssZ'))
  // 	let formatedDate = moment(timeStamp.getTime()).format('YYYY-MM-DD HH:mm:ss');

  // 	let eventDate = moment.tz(formatedDate, 'YYYY-MM-DDTHH:mm:ssZ',
  // 	this.state.transactionData.userTimezone).utc().format()

  // 	this.setState({
  // 		eventEnd: eventDate
  // 	});
  // }

  // setDuration(e) {
  // 	let startTime = new Date(this.state.eventStart);
  // 	let duration = parseInt(e);
  // 	let endTime = new Date(startTime.getTime() + duration*60000);

  // 	this.handleEventEndChange(endTime, "time");
  // }

  handleEventStartChange(date, type) {
    // console.log("handleEventStartChange date", date);
    // console.log("handleEventStartChange type", type);

    let dateStr = moment(date).format("YYYY-MM-DD");
    let timeStr = moment(date).format("HH:mm");

    // console.log("handleEventStartChange dateStr", dateStr);
    // console.log("handleEventStartChange timeStr", timeStr);

    if (type == "time") {
      dateStr = moment(this.state.eventStart).format("YYYY-MM-DD");
      // console.log("handleEventStartChange type time");
      // console.log("eventStart", this.state.eventStart);
      // console.log("dateStr", dateStr);
    }

    let finalDate = moment(dateStr + " " + timeStr);
    let timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    let formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // console.log("handleEventStartChange finalDate", finalDate);
    // console.log("handleEventStartChange timeStamp", timeStamp);
    // console.log("handleEventStartChange formatedDate", formatedDate);
    // console.log(
    //   "this.state.transactionData.userTimezone",
    //   this.state.transactionData.userTimezone
    // );

    let eventDate = moment
      .tz(
        formatedDate,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.state.transactionData.userTimezone
      )
      .utc()
      .format();

    // console.log("handleEventStartChange eventDate as eventStart", eventDate);

    if (this.state.selectedDuration) {
      this.setState(
        {
          eventStart: eventDate,
        },
        () => {
          this.setDuration(this.state.selectedDuration);
        }
      );
    } else {
      this.setState({
        eventStart: eventDate,
      });
      let eventDate_endDate = moment
        .tz(
          formatedDate,
          "YYYY-MM-DDTHH:mm:ssZ",
          this.state.transactionData.userTimezone
        )
        .add(1, "hours")
        .utc()
        .format();
      this.setState({
        eventEnd: eventDate_endDate,
      });
    }
  }

  handleEventEndChange(date, type) {
    let dateStr = moment(date).format("YYYY-MM-DD");
    let timeStr = moment(date).format("HH:mm");

    if (type == "time") {
      dateStr = moment(this.state.eventStart).format("YYYY-MM-DD");
      // console.log("===>handleEventEndChange type time");
      // console.log("eventStart", this.state.eventStart);
      // console.log("dateStr", dateStr);
    }

    let finalDate = moment(dateStr + " " + timeStr);
    let timeStamp = new Date(finalDate.format("YYYY-MM-DDTHH:mm:ssZ"));
    let formatedDate = moment(timeStamp.getTime()).format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // console.log("handleEventEndChange finalDate", finalDate);
    // console.log("handleEventEndChange timeStamp", timeStamp);
    // console.log("handleEventEndChange formatedDate", formatedDate);
    // console.log(
    //   "this.state.transactionData.userTimezone",
    //   this.state.transactionData.userTimezone
    // );

    let eventDate = moment
      .tz(
        formatedDate,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.state.transactionData.userTimezone
      )
      .utc()
      .format();

    // console.log("handleEventEndChange eventDate as eventEnd", eventDate);

    this.setState({
      eventEnd: eventDate,
    });
  }

  setDuration(e) {
    // console.log("setDuration e type", typeof e);
    this.setState({
      selectedDuration: e,
    });

    // console.log("setDuration e", e);
    // console.log("this.state.eventStart", this.state.eventStart);
    let startTime = new Date(this.state.eventStart);
    let duration = parseInt(e);
    let endTime = new Date(startTime.getTime() + duration * 60000);

    // console.log("setDuration startTime", startTime);
    // console.log("setDuration duration", duration);
    // console.log("setDuration endTime", endTime);

    let eventDate = moment
      .tz(
        endTime,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.state.transactionData.userTimezone
      )
      .utc()
      .format();

    // console.log("handleEventEndChange eventDate as eventEnd", eventDate);
    this.setState({
      eventEnd: eventDate,
    });
    // this.handleEventEndChange(endTime, "time");
  }

  checkTransactionDate(startDate) {
    let today = new Date();
    // console.log("startDate", startDate);
    // console.log("today", new Date());

    if (startDate > today) {
      return startDate;
    } else {
      return today;
    }
  }

  checkTransStartDateTime(retDate) {
    // console.log("checkTransStartDateTime retDate", retDate);
    let dateStr = moment(retDate).format("YYYY-MM-DD");
    let timeStr = moment(retDate).format("HH:mm:ss");
    let format = "HH:mm:ss";
    let time = moment(timeStr, format);
    let beforeTime = moment("08:00:00", format);
    let afterTime = moment("21:00:00", format);
    if (time.isBetween(beforeTime, afterTime)) {
      // console.log("is between");
      return retDate;
    } else {
      // console.log("is not between");
      let timeAndDate = moment(dateStr + " " + "08:00:00");
      // console.log("timeAndDate", new Date(timeAndDate));
      return new Date(timeAndDate);
    }
  }

  setDefaultDate(transStartDate) {
    // console.log("transaction start date", transStartDate);
    let retDate = this.checkTransactionDate(new Date(transStartDate));

    let expectedStartDate = this.checkTransStartDateTime(retDate);

    // console.log("expectedStartDate", expectedStartDate);

    let defStartDate = moment
      .tz(
        expectedStartDate,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.state.transactionData.userTimezone
      )
      .utc()
      .format();

    // console.log("defStartDate", defStartDate);

    let defEndDate = moment
      .tz(
        defStartDate,
        "YYYY-MM-DDTHH:mm:ssZ",
        this.state.transactionData.userTimezone
      )
      .add(1, "hours")
      .utc()
      .format();

    // console.log("defEndDate", defEndDate);

    this.setState({
      eventStart: defStartDate,
      eventEnd: defEndDate,
      selectedDuration: "60",
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    //console.log("here on form submit");
    if (
      this.state.artist &&
      this.state.artist.id &&
      this.state.transactionId &&
      this.state.eventTitle
    ) {
      let todayTZ = moment
        .tz(this.state.transactionData.userTimezone)
        .utc()
        .format();

      // console.log("today with timezone", todayTZ);
      // console.log("eventStart new Date", new Date(this.state.eventStart));
      // console.log("today with timezone new Date", new Date(todayTZ));

      if (new Date(this.state.eventStart) > new Date(todayTZ)) {
        // console.log("good to go start greater than current");
        this.setState({
          errors: "",
        });
        this.createEvent();
      } else {
        // console.log("startDate less than current. change start date/time");
        this.setState({
          errors: "Start date time is less than current date time.",
        });
      }
    } else {
      // console.log("this.state.eventStart", this.state.eventStart);
      // console.log("this.state.eventEnd", this.state.eventEnd);

      this.setState({ errors: "All fields are required" });
    }
  }

  createEvent() {
    let transId = this.state.transactionId;
    let newEventTitle = this.state.eventTitle;
    let newEventStart = this.state.eventStart;
    let newEventEnd = this.state.eventEnd;
    let newEventTime = convertTimeToMinutes(
      moment(newEventStart).get("hour") +
        ":" +
        moment(newEventStart).get("minutes")
    );
    let newEventAssigneeId = getContingencyData(
      this.state.contingencies,
      "First Appointment",
      "assignee"
    );

    let newEvent = {
      assignee: "@artist",
      campaign: "",
      communicationSubject: [""],
      communicationTo: [""],
      communicationToUserId: [newEventAssigneeId],
      communicationType: "EMAIL",
      contingency: "First Appointment",
      day: 0,
      description: [
        "<p>New appointment with @client_firstname @client_lastname.</p>\n",
      ],
      document: false,
      eventEndDate: newEventEnd,
      eventStartDate: newEventStart,
      eventType: "INTERACTIVE",
      isReminder: false,
      reminderDate: "",
      reminderTime: 540,
      specialTask: ["Appointment"],
      status: "SCHEDULED",
      time: newEventTime,
      timeZone: "240",
      title: newEventTitle,
      transactionId: transId,
    };

    if (newEvent.eventEndDate && newEvent.eventStartDate && newEvent.time) {
      this.props.createTaskAction(newEvent).then((createEventRes) => {
        if (createEventRes.status === code.OK) {
          toastMessage(code.SUCCESS, "Appointment created");
          this.props.history.push("/calendar");
          // console.log("createEvent res: ", createEventRes);
        }
      });
    }
  }

  render() {
    let contacts = this.state.contacts;
    // console.log("this.state.contacts", this.state.contacts);
    let listedContacts = [];

    for (let i = 0; i < contacts.length; i++) {
      if (!contacts[i].isDeleted) {
        listedContacts.push({
          label: contacts[i].firstname + " " + contacts[i].lastname,
          id: contacts[i]._id,
          role: contacts[i].roles,
          firstname: contacts[i].firstname,
          lastname: contacts[i].lastname,
          mobileNumber: contacts[i].mobileNumber,
          email: contacts[i].email,
        });
      }
    }

    //console.log('listedContacts ===>',listedContacts);

    listedContacts = listedContacts.filter((contactVar) => {
      return contactVar.role === "Artist" || contactVar.role === "ACCTOWNER";
    });

    if (
      this.state.userType === message.VENDOR &&
      localStorage.getItem("vendorRoleName") === "Artist" &&
      !this.checkPermission([message.manage_appointments])
    ) {
      listedContacts = listedContacts.filter((contactVar) => {
        return contactVar.id === localStorage.getItem("ID");
      });
    }

    //console.log("filtered listedContacts", listedContacts);

    let transactions = this.state.transactions;
    //console.log('transactions render',transactions);
    let listedTransactions = [];

    for (let i = 0; i < transactions.length; i++) {
      listedTransactions.push({
        label:
          transactions[i].shortName +
          " - " +
          transactions[i].dsd.buyer[0].firstname +
          (transactions[i].dsd.buyer[0].lastname
            ? " " + transactions[i].dsd.buyer[0].lastname
            : ""),
        id: transactions[i]._id,
        // contingencies: transactions[i].contingencies[i].assignee,
        status: transactions[i].status,
        contingencies: transactions[i].contingencies,
      });
    }

    return (
      <div>
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head">
          <Col xs="12" sm="4">
            <h4 className="title-med mt-0 pt-1">Create Appointment</h4>
          </Col>
        </Row>
        <div className="container-custom mt-3">
          <Form className="form-sm form-admin" onSubmit={this.handleSubmit}>
            <Row className="mb-3">
              {/* {this.state.userType === message.ACCTOWNER ? (
                <> */}
              <Col xs={12} sm={3}>
                <Form.Label>
                  Artist<span className="text-danger"> *</span>
                </Form.Label>
                <Select
                  name="artist"
                  label={listedContacts.label}
                  // options={listedContacts.filter(
                  //   (contact) => contact.role === "Artist"
                  // )}
                  options={listedContacts}
                  value={listedContacts.id}
                  placeholder="Select Artist"
                  isSearchable={true}
                  onChange={(e) => this.handleArtistSelection(e)}
                  required
                />
              </Col>
              {/* </>
              ) : (
                ""
              )} */}
              <Col xs={12} sm={3}>
                <Form.Label>
                  Artwork<span className="text-danger"> *</span>
                </Form.Label>
                <Select
                  name="transactions"
                  label={listedTransactions.label}
                  options={listedTransactions.filter(
                    (transaction) => transaction.status === "INPROGRESS"
                  )}
                  value={listedTransactions.id}
                  placeholder="Select Artwork"
                  isSearchable={true}
                  onChange={(e) => this.handleTransactionSelection(e)}
                  required
                />
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={4}>
                <Form.Group>
                  <Form.Label>
                    Appointment Name<span className="text-danger"> *</span>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) =>
                      this.handleEventTitleChange(e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={2}>
                <Form.Label>
                  Date<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Group>
                  <DatePicker
                    minDate={this.checkTransactionDate(
                      new Date(this.state.transactionData.startDate)
                    )}
                    selected={convertTZ(
                      moment(this.state.eventStart),
                      this.state.transactionData.userTimezone
                    )}
                    onChange={(date) =>
                      this.handleEventStartChange(date, "date")
                    }
                    dateFormat="MM-d-yyyy"
                    className="form-control form-control-sm pl-1 date-picker"
                    disabled={this.state.transactionId === ""}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={2}>
                <Form.Label>
                  Time<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Group>
                  <DatePicker
                    selected={convertTZ(
                      moment(this.state.eventStart),
                      this.state.transactionData.userTimezone
                    )}
                    onChange={(date) =>
                      this.handleEventStartChange(date, "time")
                    }
                    showTimeSelect
                    showTimeSelectOnly
                    // minTime={new Date(new Date().setHours(8, 0, 0, 0))}
                    // maxTime={new Date(new Date().setHours(21, 0, 0, 0))}
                    timeIntervals={30}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    className="form-control form-control-sm pl-1 date-picker"
                    disabled={this.state.transactionId === ""}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={2}>
                <Form.Label>
                  Duration<span className="text-danger"> *</span>
                </Form.Label>
                <Form.Group>
                  <select
                    className="form-control form-control-sm pl-1 date-picker"
                    value={this.state.selectedDuration}
                    onChange={(e) => this.setDuration(e.target.value)}
                    disabled={this.state.transactionId === ""}
                  >
                    <option value={15}>15 minutes</option>
                    <option value={20}>20 minutes</option>
                    <option value={30}>30 minutes</option>
                    <option value={45}>45 minutes</option>
                    <option value={60}>1 hour</option>
                    <option value={120}>2 hours</option>
                    <option value={180}>3 hours</option>
                    <option value={240}>4 hours</option>
                  </select>
                </Form.Group>
              </Col>
            </Row>
            {this.state.errors ? (
              <Row className="mt-2">
                <Col xs={12} sm={4}>
                  <div className="text-danger">{this.state.errors}</div>
                </Col>
              </Row>
            ) : (
              ""
            )}
            <Row>
              <Col xs={12} sm={4}>
                <Button
                  type="submit"
                  style={{ backgroundColor: "#379143", color: "#FFFFFF" }}
                  className="mt-3 mb-3"
                  //onClick={() => this.createEvent()}
                >
                  Create Appointment
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    vendorTransactions: state.reducer.vendorTransactions,
    transactions: state.reducer.transactions,
    transactionData: state.reducer.transactionData,
    tasks: state.reducer.tasks,
  };
};

export default connect(
  mapStateToProps,
  {
    getVendorTransactionsAction,
    getAllTransactionsAction,
    getContactsActions,
    getUserRolesAction,
    getTransactionDataAction,
    getAllTasksAction,
    createTaskAction,
    getOwnerContactsAction,
    getAllTransactionsActionNew,
  }
)(ExisitingTransaction);
